import type { ReactNode } from "react";
import styles from "./NoticeBanner.module.css";

// The page-wide strip under the top of every page: a notice and the one
// action that resolves it.
export const NoticeBanner = ({
  children,
  action,
  onAction,
  busy,
  tone = "notice",
}: {
  children: ReactNode;
  action: string;
  onAction: () => void;
  busy: boolean;
  tone?: "notice" | "required";
}) => (
  <div
    className={`${styles.banner} ${tone === "required" ? styles.required : ""}`}
    role="alert"
  >
    <span className={styles.icon} aria-hidden="true">!</span>
    <span className={styles.text}>{children}</span>
    <button
      type="button"
      className={styles.button}
      onClick={onAction}
      disabled={busy}
    >
      {action}
    </button>
  </div>
);
